import { useCallback, useState } from 'react'

interface UsePickerOpenStateParams {
    initialIsOpen: boolean
    controlledIsOpen?: boolean
    onIsOpenChange?: (isOpen: boolean) => void
}

const usePickerOpenState = ({
    initialIsOpen,
    controlledIsOpen,
    onIsOpenChange,
}: UsePickerOpenStateParams) => {
    const [internalOpen, setInternalOpen] = useState(initialIsOpen)

    const isControlled = controlledIsOpen !== undefined
    const isOpen = isControlled ? controlledIsOpen : internalOpen

    const setIsOpen = useCallback(
        (value: boolean) => {
            if (!isControlled) {
                setInternalOpen(value)
            }
            onIsOpenChange?.(value)
        },
        [isControlled, onIsOpenChange],
    )

    return { isOpen, setIsOpen }
}

export default usePickerOpenState
